// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._quenze3t [data-smart-element-group]{gap:var(--ds-space-0,0)}\n._zulpu2gc{gap:var(--ds-space-100,8px)}._13mh1pd9 [data-smart-element=Title]{font-weight:var(--ds-font-weight-semibold,600)}\n._3um015vq{visibility:hidden}\n._ca0q1b66{padding-top:var(--ds-space-050,4px)}\n._kqswstnw{position:absolute}\n._n3td1b66{padding-bottom:var(--ds-space-050,4px)}\n._oebj1txw [data-smart-element-group]{display:flex}", ""]);
// Exports
module.exports = exports;
